import React, { useEffect } from 'react';
import { Flex, Text, Icon, Box } from '@chakra-ui/react';

interface ToastProps {
  title: string;
  description: string;
  onClose: () => void;
  duration?: number;
  variant?: 'critical' | 'info';
}

const STYLES = {
  critical: {
    bg: '#FBCDD1',
    border: '#F79997',
    titleColor: '#C4040B',
    descColor: '#C4040B',
    closeColor: '#9D1615',
    iconBg: '#D21C1B',
  },
  info: {
    bg: '#E8F4FD',
    border: '#D0E9FB',
    titleColor: '#005AA3',
    descColor: '#005AA3',
    closeColor: '#005AA3',
    iconBg: '#006699',
  },
};

const InfoCircleIcon: React.FC<{ bg: string }> = ({ bg }) => (
  <Icon viewBox="0 0 24 24" boxSize="24px" flexShrink={0}>
    <circle cx="12" cy="12" r="10" fill={bg} />
    <rect x="11" y="11" width="2" height="6" rx="1" fill="#FFFFFF" />
    <rect x="11" y="6" width="2" height="2" rx="1" fill="#FFFFFF" />
  </Icon>
);

const CloseIcon: React.FC<{ color: string }> = ({ color }) => (
  <Icon viewBox="0 0 16 16" boxSize="16px" flexShrink={0}>
    <path
      d="M12.5 4.21L11.29 3L8 6.29L4.71 3L3.5 4.21L6.79 7.5L3.5 10.79L4.71 12L8 8.71L11.29 12L12.5 10.79L9.21 7.5L12.5 4.21Z"
      fill={color}
    />
  </Icon>
);

const Toast: React.FC<ToastProps> = ({ title, description, onClose, duration = 30000, variant = 'critical' }) => {
  const s = STYLES[variant];

  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <Flex
      boxSizing="border-box"
      direction="row"
      align="flex-start"
      p="16px"
      gap="12px"
      w={variant === 'info' ? '478px' : '449px'}
      maxW="95vw"
      bg={s.bg}
      border={`1px solid ${s.border}`}
      borderRadius="4px"
    >
      <InfoCircleIcon bg={s.iconBg} />

      <Flex direction="column" gap="4px" flex="1">
        <Text
          fontFamily="'Open Sans'"
          fontWeight={700}
          fontSize="14px"
          lineHeight="120%"
          letterSpacing="0.01em"
          color={s.titleColor}
          style={{ color: s.titleColor }}
        >
          {title}
        </Text>
        <Text
          fontFamily="'Open Sans'"
          fontWeight={400}
          fontSize="14px"
          lineHeight="150%"
          letterSpacing="0.01em"
          color={s.descColor}
          style={{ color: s.descColor }}
        >
          {description}
        </Text>
      </Flex>

      <Box as="button" onClick={onClose} cursor="pointer" lineHeight={0}>
        <CloseIcon color={s.closeColor} />
      </Box>
    </Flex>
  );
};

export default Toast;
